import { render } from "./tab-content-item.vue?vue&type=template&id=56806729"
import script from "./tab-content-item.vue?vue&type=script&lang=js"
export * from "./tab-content-item.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__